import { render, staticRenderFns } from "./GotoNext.vue?vue&type=template&id=a6346540"
import script from "./GotoNext.vue?vue&type=script&lang=js"
export * from "./GotoNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports